export const CONNECT_KEYBOARD_TO_INPUT = 'CONNECT_KEYBOARD_TO_INPUT';
export type CONNECT_KEYBOARD_TO_INPUT = typeof CONNECT_KEYBOARD_TO_INPUT;

export const DISCONNECT_KEYBOARD = 'DISCONNECT_KEYBOARD';
export type DISCONNECT_KEYBOARD = typeof DISCONNECT_KEYBOARD;

export const TOGGLE_KEYBOARD_DISABLE_VALUE = 'TOGGLE_KEYBOARD_DISABLE_VALUE';
export type TOGGLE_KEYBOARD_DISABLE_VALUE = typeof TOGGLE_KEYBOARD_DISABLE_VALUE;

export const SEND_KEYBOARD_VALUE = 'SEND_KEYBOARD_VALUE';
export type SEND_KEYBOARD_VALUE = typeof SEND_KEYBOARD_VALUE;

export const SETUP_ENTER_FUNCTION = 'SETUP_ENTER_FUNCTION';
export type SETUP_ENTER_FUNCTION = typeof SETUP_ENTER_FUNCTION;

export const CHANGE_KEYBOARD_MASK = 'CHANGE_KEYBOARD_MASK';
export type CHANGE_KEYBOARD_MASK = typeof CHANGE_KEYBOARD_MASK;



// WEBPACK FOOTER //
// ./src/store/Keyboard/constants.ts